import {jsonMember, jsonObject} from "typedjson";
import {DxListMessageOptions} from "./dx-list-message-options";
import {DxListToolbarOptions} from "./toolbar/dx-list-toolbar-options";


@jsonObject
export class DxListOptions {
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: false, isRequired: false})
  protected _id: number;

  @jsonMember({name: "ident", constructor: String, emitDefaultValue: false, isRequired: false})
  protected _ident: string;

  @jsonMember({name: "title", constructor: String, emitDefaultValue: false, isRequired: false})
  protected _title: string;

  @jsonMember({name: "dataSourceIdent", constructor: String, emitDefaultValue: false, isRequired: false})
  private _dataSourceIdent: string;

  @jsonMember({name: "dataProviderFactoryIdent", constructor: String, emitDefaultValue: false, isRequired: false})
  private _dataProviderFactoryIdent: string;

  @jsonMember({name: "actionResolverIdent", constructor: String, emitDefaultValue: false, isRequired: false})
  private _actionResolverIdent: string;

  @jsonMember({name: "modalsProviderIdent", constructor: String, emitDefaultValue: false, isRequired: false})
  private _modalsProviderIdent: string;

  @jsonMember({name: "allowMultiSelect", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  protected _allowMultiSelect: boolean = false;

  @jsonMember({name: "selectNextAfterRemove", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  protected _selectNextAfterRemove: boolean = true;

  @jsonMember({name: "showToolbar", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  protected _showToolbar: boolean = false;

  @jsonMember({name: "showSearchBox", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  protected _showSearchBox: boolean = false;

  @jsonMember({name: "externalToolbarHandler", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  protected _externalToolbarHandler: boolean = false;

  @jsonMember({name: "noDataMessageOptions", constructor: DxListMessageOptions, emitDefaultValue: false, isRequired: false})
  protected _noDataMessageOptions: DxListMessageOptions;

  @jsonMember({name: "errorMessageOptions", constructor: DxListMessageOptions, emitDefaultValue: false, isRequired: false})
  private _errorMessageOptions: DxListMessageOptions;

  @jsonMember({name: "toolbar", constructor: DxListToolbarOptions, emitDefaultValue: false, isRequired: false})
  protected _toolbar: DxListToolbarOptions;

  @jsonMember({name: "useModalForEdit", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _useModalForEdit: boolean = false;

  /** показывать описание второй строкой списка */
  @jsonMember({name: "showDescription", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _showDescription: boolean = false;

  /*@jsonMember({ elements: TaskListFilter, name: "filters", emitDefaultValue: false, isRequired: false })
  protected _filters: TaskListFilter[];

  @jsonMember({ elements: TaskListSort, name: "sorts", emitDefaultValue: false, isRequired: false })
  protected _sorts: TaskListSort[];*/


  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get title(): string {
    return this._title;
  }

  set title(value: string) {
    this._title = value;
  }

  get ident(): string {
    return this._ident;
  }

  get dataSourceIdent(): string {
    return this._dataSourceIdent;
  }

  set dataSourceIdent(value: string) {
    this._dataSourceIdent = value;
  }

  get dataProviderFactoryIdent(): string {
    return this._dataProviderFactoryIdent;
  }

  set dataProviderFactoryIdent(value: string) {
    this._dataProviderFactoryIdent = value;
  }

  get actionResolverIdent(): string {
    return this._actionResolverIdent;
  }

  set actionResolverIdent(value: string) {
    this._actionResolverIdent = value;
  }

  get modalsProviderIdent(): string {
    return this._modalsProviderIdent;
  }

  set modalsProviderIdent(value: string) {
    this._modalsProviderIdent = value;
  }

  set ident(value: string) {
    this._ident = value;
  }

  get allowMultiSelect(): boolean {
    return this._allowMultiSelect;
  }

  set allowMultiSelect(value: boolean) {
    this._allowMultiSelect = value;
  }

  get selectNextAfterRemove(): boolean {
    return this._selectNextAfterRemove;
  }

  set selectNextAfterRemove(value: boolean) {
    this._selectNextAfterRemove = value;
  }

  get showToolbar(): boolean {
    return this._showToolbar;
  }

  set showToolbar(value: boolean) {
    this._showToolbar = value;
  }

  get externalToolbarHandler(): boolean {
    return this._externalToolbarHandler;
  }

  set externalToolbarHandler(value: boolean) {
    this._externalToolbarHandler = value;
  }

  get showSearchBox(): boolean {
    return this._showSearchBox;
  }

  set showSearchBox(value: boolean) {
    this._showSearchBox = value;
  }

  get noDataMessageOptions(): DxListMessageOptions {
    return this._noDataMessageOptions;
  }

  set noDataMessageOptions(value: DxListMessageOptions) {
    this._noDataMessageOptions = value;
  }

  get errorMessageOptions(): DxListMessageOptions {
    return this._errorMessageOptions;
  }

  set errorMessageOptions(value: DxListMessageOptions) {
    this._errorMessageOptions = value;
  }

  get toolbar(): DxListToolbarOptions {
    return this._toolbar;
  }

  set toolbar(value: DxListToolbarOptions) {
    this._toolbar = value;
  }

  get useModalForEdit(): boolean {
    return this._useModalForEdit;
  }

  set useModalForEdit(value: boolean) {
    this._useModalForEdit = value;
  }

  get showDescription(): boolean {
    return this._showDescription;
  }

  set showDescription(value: boolean) {
    this._showDescription = value;
  }
}
